import { Box, BoxProps, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface SimTabContent {
    icon?: string | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    label: React.ReactNode,
    content: React.ReactNode;
}

export const SimTabs = (props: BoxProps & { tabs: SimTabContent[], defaultTab?: number; }) => {

    const { tabs, defaultTab, ...boxProps } = props;
    const [value, setValue] = React.useState(0);

    React.useEffect(() => {
        if (props.defaultTab) {
            setValue(props.defaultTab);
        }
    }, []);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return <Box sx={{ width: '100%' }} {...boxProps}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange}>
                {props.tabs.map((p, index) => <Tab icon={p.icon} label={p.label} {...a11yProps(index)} />)}
            </Tabs>
        </Box>
        {props.tabs.map((p, index) => <CustomTabPanel key={index} value={value} index={index}>{p.content}</CustomTabPanel>)}
    </Box>;
};

const samePageLinkNavigation = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
) => {
    if (
        event.defaultPrevented ||
        event.button !== 0 || // ignore everything but left-click
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
    ) {
        return false;
    }
    return true;
};

interface LinkTabProps {
    icon?: string | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    label?: string;
    to: string;
    selected?: boolean;
    content: React.ReactNode;
}

const LinkTab = (props: LinkTabProps) => {
    const { content, ...restProps } = props;
    return (
        <Tab
            component={Link}
            /*onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                // Routing libraries handle this, you can remove the onClick handle when using them.
                if (samePageLinkNavigation(event)) {
                    event.preventDefault();
                }
            }}*/
            aria-current={props.selected && 'page'}
            {...restProps}
        />
    );
};
export interface SimLinkTabContent extends SimTabContent {
    url: string;
}
export const SimLinkTabs = (props: BoxProps & { tabs: LinkTabProps[], defaultTab?: number; }) => {

    const { tabs, defaultTab, ...boxProps } = props;
    const [value, setValue] = React.useState(0);

    React.useEffect(() => {
        if (props.defaultTab) {
            setValue(props.defaultTab);
        }
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // event.type can be equal to focus with selectionFollowsFocus.
        if (
            event.type !== 'click' ||
            (event.type === 'click' &&
                samePageLinkNavigation(
                    event as React.MouseEvent<HTMLAnchorElement, MouseEvent>,
                ))
        ) {
            setValue(newValue);
        }
    };

    return <Box sx={{ width: '100%' }} {...boxProps}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange}>
                {props.tabs.map((p, i) => <LinkTab key={i} {...p} />)}
            </Tabs>
        </Box>
        {props.tabs.map((p, index) => <CustomTabPanel key={index} value={value} index={index}>{p.content}</CustomTabPanel>)}
    </Box>;
};
